import "./Button.scss";

const Button = ({ buttonText }) => {
  return <button className="button">{buttonText}</button>;
};

export default Button;
